












import {Component, Prop, Vue} from 'vue-property-decorator';
import {CustomerProfileStore, EMBED_MODE, UIStore} from '../../../store';
import {EnterPhoneVerifyPin} from '../../../components';
import type {ILandingPageElementSignup} from '../../../store';
import type {ILBElementComponent} from '../../../types';


@Component({
	components: {
		EnterPhoneVerifyPin,
	}
})
export default class LBElementSignup extends Vue implements ILBElementComponent {
	@Prop({required: true})
	element!: ILandingPageElementSignup;

	get isEmbedded(): boolean {
		return UIStore.embedMode !== EMBED_MODE.NONE;
	}

	get isLoggedIn(): boolean {
		return CustomerProfileStore.customerProfile !== null;
	}
}
